/** Valores por defecto de negocio (ajustar solo aquí si la marca cambia los textos). */
export const UTM_DEFAULT_SOURCE = "organico";
export const UTM_DEFAULT_MEDIUM = "web";
export const UTM_DEFAULT_CAMPAIGN = "landing_web_ford";

export function normalizeParam(value) {
  if (value == null) return null;
  const s = String(value).trim();
  return s || null;
}

export function sanitizeMarketingUtmSource(value) {
  const n = normalizeParam(value);
  if (!n) return null;
  const compact = n.replace(/\s+/g, " ").replace(/_/g, " ").trim();
  if (/^consulta web$/i.test(compact)) return null;
  if (compact.toLowerCase() === "directo") return null;
  return n;
}

export function urlSinUtmsPrincipales(query) {
  return !query.get("utm_source") && !query.get("utm_medium") && !query.get("utm_campaign");
}

function resolveUtmSource(query, sessionValue) {
  if (query.has("utm_source")) {
    return sanitizeMarketingUtmSource(query.get("utm_source")) ?? UTM_DEFAULT_SOURCE;
  }
  return sanitizeMarketingUtmSource(sessionValue) ?? UTM_DEFAULT_SOURCE;
}

function resolveUtmMedium(query, sessionValue) {
  return normalizeParam(query.get("utm_medium")) || normalizeParam(sessionValue) || UTM_DEFAULT_MEDIUM;
}

function resolveUtmCampaign(query, sessionValue) {
  return normalizeParam(query.get("utm_campaign")) || normalizeParam(sessionValue) || UTM_DEFAULT_CAMPAIGN;
}

export function resolveUtmParams(search = typeof window !== "undefined" ? window.location.search : "") {
  const query = new URLSearchParams(search);
  const getSession = (key) =>
    typeof sessionStorage !== "undefined" ? sessionStorage.getItem(key) : null;

  if (urlSinUtmsPrincipales(query)) {
    return {
      utm_source: UTM_DEFAULT_SOURCE,
      utm_medium: UTM_DEFAULT_MEDIUM,
      utm_campaign: UTM_DEFAULT_CAMPAIGN,
      utm_term: "",
    };
  }

  return {
    utm_source: resolveUtmSource(query, getSession("utm_source")),
    utm_medium: resolveUtmMedium(query, getSession("utm_medium")),
    utm_campaign: resolveUtmCampaign(query, getSession("utm_campaign")),
    utm_term: normalizeParam(query.get("utm_term")) || normalizeParam(getSession("utm_term")) || "",
  };
}
